package com.bikompanion.data.gbfs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsSystemInformationDto(
    @SerialName("system_id") val systemId: String = "",
    @Serializable(with = GbfsTextSerializer::class) val name: String = "",
    @Serializable(with = GbfsTextSerializer::class) val operator: String = "",
    val url: String? = null,
    @SerialName("license_id") val licenseId: String? = null,
    @SerialName("license_url") val licenseUrl: String? = null,
    @SerialName("terms_url")
    @Serializable(with = GbfsTextSerializer::class)
    val termsUrl: String = "",
)
